import toast, { Toaster } from 'react-hot-toast';

// Configure toast with brand colors
export const showToast = {
  success: (message) => {
    toast.success(message, {
      style: {
        background: '#111317',
        color: '#F3F4F6',
        border: '1px solid #D4AF37',
        borderRadius: '12px',
        padding: '12px 16px',
      },
      iconTheme: {
        primary: '#D4AF37',
        secondary: '#0B0B0D',
      },
    });
  },
  error: (message) => {
    toast.error(message, {
      style: {
        background: '#111317',
        color: '#F3F4F6',
        border: '1px solid #dc2626',
        borderRadius: '12px',
        padding: '12px 16px',
      },
      iconTheme: {
        primary: '#dc2626',
        secondary: '#111317',
      },
    });
  },
  loading: (message) => {
    return toast.loading(message, {
      style: {
        background: '#111317',
        color: '#F3F4F6',
        border: '1px solid #9CA3AF',
        borderRadius: '12px',
        padding: '12px 16px',
      },
    });
  },
  dismiss: (toastId) => {
    toast.dismiss(toastId);
  },
};

// Toast container with custom positioning
export const ToastContainer = () => (
  <Toaster
    position="top-center"
    toastOptions={{
      duration: 3000,
      style: {
        background: '#111317',
        color: '#F3F4F6',
      },
    }}
  />
);

export default showToast;
